import React, {
  useState,
} from "react";

import {
  useParams,
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import cricketImg from "../assets/sports/cricket.jpg";
import basketballImg from "../assets/sports/basketball.jpg";
import volleyballImg from "../assets/sports/volleyball.jpg";
import badmintonImg from "../assets/sports/badminton.jpg";
import taekwondoImg from "../assets/sports/taekwondo.jpg";
import chessImg from "../assets/sports/chess.jpg";
import carromImg from "../assets/sports/carrom.jpg";
import athleticsImg from "../assets/sports/athletics.jpg";
import skatingImg from "../assets/sports/skating.jpg";

const SportDetails = () => {
  const { slug } =
    useParams();

  const [open, setOpen] =
    useState(false);

  const sportsData = {
    cricket: {
      title: "CRICKET",
      image: cricketImg,

      description:
        "The school also has individual cemented cricket pitch for the students of the junior and senior block and has kept it mandatory for all the students to learn cricket. In order to inculcate the spirit of sportsmanship and competition, the school conducts various sports events and also organizes athletic Meet/Sports Day every year in the School.",
    },

    basketball: {
      title: "BASKETBALL",
      image: basketballImg,

      description:
        "Basketball activities help students improve teamwork, coordination and fitness. Students actively participate in inter-school competitions and practice sessions.",
    },

    volleyball: {
      title: "VOLLEYBALL",
      image: volleyballImg,

      description:
        "Volleyball develops discipline, team spirit and physical endurance among students with regular coaching and tournaments.",
    },

    badminton: {
      title: "BADMINTON",
      image: badmintonImg,

      description:
        "The school provides badminton facilities for students to enhance their agility, concentration and fitness.",
    },

    taekwondo: {
      title: "TAEKWONDO",
      image: taekwondoImg,

      description:
        "Taekwondo training builds self-confidence, discipline and self-defense skills among students.",
    },

    chess: {
      title: "CHESS",
      image: chessImg,

      description:
        "Chess improves strategic thinking and mental sharpness while encouraging healthy competition.",
    },

    carrom: {
      title: "CARROM",
      image: carromImg,

      description:
        "Carrom activities help students improve focus and coordination through indoor gaming activities.",
    },

    athletics: {
      title: "ATHLETICS",
      image: athleticsImg,

      description:
        "Athletic events encourage students to participate in running, jumping and fitness-based activities.",
    },

    skating: {
      title: "SKATING",
      image: skatingImg,

      description:
        "Skating activities improve body balance, flexibility and confidence among students.",
    },
  };

  const sport =
    sportsData[slug];

  if (!sport) {
    return (
      <h1 className="text-center text-4xl font-bold py-20">
        Sport Not Found
      </h1>
    );
  }

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      <section className="bg-[#f7f9fc] py-10 md:py-16">

        {/* SPORTS TAB MENU */}
        <div className="bg-[#D4A017] mb-10 shadow-md">

          <div className="max-w-7xl mx-auto px-4 overflow-x-auto">

            <div className="flex items-center gap-2 md:gap-4 min-w-max py-4 text-white text-sm md:text-base font-medium">

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/cricket"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug === "cricket"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Cricket
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/basketball"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug ===
                  "basketball"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Basketball
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/volleyball"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug ===
                  "volleyball"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Volleyball
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/badminton"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug ===
                  "badminton"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Badminton
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/taekwondo"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug ===
                  "taekwondo"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Taekwondo
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/chess"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug === "chess"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Chess
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/carrom"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug === "carrom"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Carrom
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/athletics"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug ===
                  "athletics"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Athletics
              </button>

              <span>|</span>

              <button
                onClick={() =>
                  window.location.href =
                    "/sports/skating"
                }
                className={`px-4 py-2 rounded-md transition-all duration-300 ${
                  slug === "skating"
                    ? "bg-white text-[#072F5F] font-bold"
                    : "hover:bg-white/20"
                }`}
              >
                Skating
              </button>

            </div>

          </div>

        </div>

        {/* SPORT CARD */}
        <div className="max-w-5xl mx-auto px-5">

          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">

            {/* TITLE */}
            <div className="bg-[#D4A017] py-5 text-center">

              <h1 className="text-4xl md:text-5xl font-bold text-white">

                {sport.title}

              </h1>

            </div>

            {/* IMAGE */}
            <img
              src={sport.image}
              alt={sport.title}
              className="w-full h-[250px] md:h-[500px] object-cover"
            />

            {/* DESCRIPTION */}
            <div className="p-6 md:p-10">

              <p className="text-gray-700 leading-8 md:leading-9 text-base md:text-lg">

                {sport.description}

              </p>

            </div>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default SportDetails;